import { render, staticRenderFns } from "./HomeKunde.vue?vue&type=template&id=7b63eb13&scoped=true&"
import script from "./HomeKunde.vue?vue&type=script&lang=js&"
export * from "./HomeKunde.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b63eb13",
  null
  
)

export default component.exports